import React from 'react';

import { Badge } from '@sbt-web/ui';

import commonClasses from '../SelectorStyles/common.module.scss';

const NewBadge = () => {
  return (
    <Badge themed classes={[commonClasses['novelty-badge']]}>
      Novità
    </Badge>
  );
};

export default NewBadge;
